export const imageFieldPreview = {
	init: () => {
		document.querySelectorAll( '.image-field-with-preview' ).forEach( ( wrapper ) => {
			const imgField = wrapper.querySelector( 'input[type=file]' );
			imgField.addEventListener( 'change', ( e ) => {
				const [ file ] = e.target.files;
				if ( file ) {
					const imgPreviewWrapper = wrapper.querySelector( '.image-preview' );
					const imgPreview = imgPreviewWrapper.querySelector( 'img' );
					imgPreviewWrapper.classList.remove( 'hidden' );
					imgPreview.src = URL.createObjectURL( file );
				}
			} );
		} );
	},
};
